import updateZoom from './updateZoom';
import mapCenterHandler from './mapCenterHandler';

// Sets the map viewport to contain the given bounds.
export default function (map, locations, mapMarkers, padding, zoom) {
  map.setCenter({ lat: null, lng: null });
  // if we have a list of locations, we will use the map bounds to set the map center and its viewport
  // if we have only one location, the map bounds won't work with given paddings, so we will have to directly set the map center
  if (locations?.length === 1) {
    mapCenterHandler(map, locations[0], padding, zoom);
    return;
  }

  const bounds = new window.woosmap.map.LatLngBounds();

  mapMarkers.forEach(marker => {
    bounds.extend(marker.getPosition());
  });

  map.fitBounds(bounds, padding);
  updateZoom(map, zoom);
}
